// Shared creative content data - used by all creative page variants

// Music tracks
import GraengaleDawn from "../assets/Stories/Graengale Grove/Graengale Grove (Dawn).mp3";
import GraengaleLight from "../assets/Stories/Graengale Grove/Graengale Grove (Light).mp3";
import GraengaleMorningSong from "../assets/Stories/Graengale Grove/Graengale Grove (Morning Song).mp3";
import GraengaleBallad from "../assets/Stories/Graengale Grove/The Ballad of Graengale Grove.mp3";
import GraengaleTwilight from "../assets/Stories/Graengale Grove/Graengalen Gehölz (Dämmerung).mp3";
import GraengaleNightSong from "../assets/Stories/Graengale Grove/Graengalen Gehölz (Nachtlied).mp3";
import GraengaleDark from "../assets/Stories/Graengale Grove/Graengalen Gehölz (Dunkel).mp3";

// Album covers
import VenerannCover from "../assets/Songs/Venerann's Ember Tide/Cover.png";
import SapphireShoreCover from "../assets/Songs/Osgara - The Sapphire Shore/Cover.png";
import EmberTideCover from "../assets/Songs/Osgara - The Ember Tide/Cover.png";
import ScoundrelsCover from "../assets/Songs/Scoundrel's Shanties/cover.png";

// Venerann's Ember Tide tracks
import VenerannT01 from "../assets/Songs/Venerann's Ember Tide/01 - The Ember Tide.mp3";
import VenerannT02 from "../assets/Songs/Venerann's Ember Tide/02 - Cleansing Flame.mp3";
import VenerannT03 from "../assets/Songs/Venerann's Ember Tide/03 - Sapphire Lords.mp3";
import VenerannT04 from "../assets/Songs/Venerann's Ember Tide/04 - The Dragon and The Flame.mp3";
import VenerannT05 from "../assets/Songs/Venerann's Ember Tide/05 - Last of the Sapphire Guard.mp3";
import VenerannT06 from "../assets/Songs/Venerann's Ember Tide/06 - Ember's Flow.mp3";
import VenerannT07 from "../assets/Songs/Venerann's Ember Tide/07 - Warbearers.mp3";
import VenerannT08 from "../assets/Songs/Venerann's Ember Tide/08 - To Magic's End.mp3";
import VenerannT09 from "../assets/Songs/Venerann's Ember Tide/09 - Ember's Call.mp3";
import VenerannT10 from "../assets/Songs/Venerann's Ember Tide/10 - Throvia.mp3";

// Osgara - The Sapphire Shore tracks
import SapphireT00 from "../assets/Songs/Osgara - The Sapphire Shore/00 - Prologue.mp3";
import SapphireT01 from "../assets/Songs/Osgara - The Sapphire Shore/01 - Ashes of Novgara.mp3";
import SapphireT02 from "../assets/Songs/Osgara - The Sapphire Shore/02 - The Battle of Ash.mp3";
import SapphireT03 from "../assets/Songs/Osgara - The Sapphire Shore/03 - Sapphire Lords.mp3";
import SapphireT04 from "../assets/Songs/Osgara - The Sapphire Shore/04 - Bastion of the Mark.mp3";
import SapphireT05 from "../assets/Songs/Osgara - The Sapphire Shore/05 - Ready my Steed.mp3";
import SapphireT06 from "../assets/Songs/Osgara - The Sapphire Shore/06 - The Sapphire Coup.mp3";
import SapphireT07 from "../assets/Songs/Osgara - The Sapphire Shore/07 - Thousands.mp3";
import SapphireT08 from "../assets/Songs/Osgara - The Sapphire Shore/08 - The Symphony of Grahir.mp3";
import SapphireT09 from "../assets/Songs/Osgara - The Sapphire Shore/09 - The Sound of Steel.mp3";
import SapphireT10 from "../assets/Songs/Osgara - The Sapphire Shore/10 - The Shattering.mp3";
import SapphireT11 from "../assets/Songs/Osgara - The Sapphire Shore/11 - Herald of War.mp3";
import SapphireT12 from "../assets/Songs/Osgara - The Sapphire Shore/12 - The Sapphire Shore.mp3";

// Osgara - The Ember Tide tracks
import EmberT01 from "../assets/Songs/Osgara - The Ember Tide/01 - Risen in Ember.mp3";
import EmberT02 from "../assets/Songs/Osgara - The Ember Tide/02 - Ember Epoch.mp3";
import EmberT03 from "../assets/Songs/Osgara - The Ember Tide/03 - Petty Squabbles (Gothic).mp3";
import EmberT04 from "../assets/Songs/Osgara - The Ember Tide/04 - Northern Visitor.mp3";
import EmberT05 from "../assets/Songs/Osgara - The Ember Tide/05 - Magicide.mp3";
import EmberT06 from "../assets/Songs/Osgara - The Ember Tide/06 - Flame Eternal.mp3";
import EmberT07 from "../assets/Songs/Osgara - The Ember Tide/07 - To Magics End.mp3";
import EmberT08 from "../assets/Songs/Osgara - The Ember Tide/08 - Fall from Grace.mp3";
import EmberT09 from "../assets/Songs/Osgara - The Ember Tide/14 - Reverie of Cinder (Remix).mp3";

// Scoundrel's Shanties tracks
import ScoundrelT01 from "../assets/Songs/Scoundrel's Shanties/01 - The Endless Sea (New).mp3";
import ScoundrelT02 from "../assets/Songs/Scoundrel's Shanties/02 - Scoundrel's Song.mp3";
import ScoundrelT03 from "../assets/Songs/Scoundrel's Shanties/03 - Far Waters.mp3";
import ScoundrelT04 from "../assets/Songs/Scoundrel's Shanties/04 - Migoran Bounty.mp3";
import ScoundrelT05 from "../assets/Songs/Scoundrel's Shanties/05 - Blood of Salt.mp3";
import ScoundrelT06 from "../assets/Songs/Scoundrel's Shanties/06 - Deckhand Shanty #6 (Shallow).mp3";
import ScoundrelT07 from "../assets/Songs/Scoundrel's Shanties/07 - Deckhand Shanty #6 (Deep).mp3";
import ScoundrelT08 from "../assets/Songs/Scoundrel's Shanties/08 - Deckhand Shanty #6 (Far Waters).mp3";
import ScoundrelT09 from "../assets/Songs/Scoundrel's Shanties/09 - Scoundrel's You & I.mp3";
import ScoundrelT10 from "../assets/Songs/Scoundrel's Shanties/10 - O Bountiful Sea.mp3";
import ScoundrelT11 from "../assets/Songs/Scoundrel's Shanties/13 - Sanity's Edge.mp3";
import ScoundrelT12 from "../assets/Songs/Scoundrel's Shanties/13 - Sanity's Edge (Ballad).mp3";
import ScoundrelT13 from "../assets/Songs/Scoundrel's Shanties/14 - Far Voyage.mp3";
import ScoundrelT14 from "../assets/Songs/Scoundrel's Shanties/15 - Deckhand Shanty #6 (Captain's Song).mp3";

// Game covers
import KotchCover from "../components/Kotch/cover.png";
import BountifulSeaCover from "../components/BountifulSea/cover.png";
import SandsOfExileCover from "../components/SandsOfExile/cover.png";

// Paintings
import Painting1 from "../assets/Paintings/Crop20181015_105311.jpg";
import Painting2 from "../assets/Paintings/Crop20181015_105323.jpg";
import Painting3 from "../assets/Paintings/Crop20181015_105332.jpg";
import Painting4 from "../assets/Paintings/Crop20181015_105342.jpg";
import Painting5 from "../assets/Paintings/Crop20181015_105445.jpg";
import Painting6 from "../assets/Paintings/Crop20181015_105511.jpg";
import Painting7 from "../assets/Paintings/Crop20181015_105520.jpg";
import Painting8 from "../assets/Paintings/Crop20181015_105529.jpg";
import Painting9 from "../assets/Paintings/Crop20181015_105632.jpg";
import Painting10 from "../assets/Paintings/Crop20190412_143853.jpg";
import Painting11 from "../assets/Paintings/Crop20191212_121100.jpg";
import Painting12 from "../assets/Paintings/Crop20191222_165203.jpg";
import Painting13 from "../assets/Paintings/Crop20200115_091924.jpg";
import Painting14 from "../assets/Paintings/Crop20200516_195759.jpg";
import Painting15 from "../assets/Paintings/20201221_090743Crop.jpg";
import Painting16 from "../assets/Paintings/20210404_162124.jpg";
import Painting17 from "../assets/Paintings/IMG_20220104_043017_643.jpg";
import Painting18 from "../assets/Paintings/20190412_143904.jpg";
import Painting19 from "../assets/Paintings/20190509_103003.jpg";

// Author photo
import AuthorPhoto from "../assets/AuthorPhoto.jpg";

// ─── Types ───────────────────────────────────────────────────

export interface World {
  id: string;
  name: string;
  subtitle?: string;
  description: string;
  features: { title: string; description: string }[];
  link?: { url: string; label: string };
}

export interface Book {
  title: string;
  status: string;
  link: string;
  free?: boolean;
}

export type Medium = "Oils" | "Acrylics";

export interface Painting {
  src: string;
  title: string;
  medium: Medium;
}

export interface MusicTrack {
  id: string;
  title: string;
  src: string;
}

export interface MusicAlbum {
  id: string;
  title: string;
  description: string;
  cover?: string;
  tracks: MusicTrack[];
}

export interface VideoItem {
  id: string;
  title: string;
}

export interface Game {
  id: string;
  title: string;
  year: number;
  description: string;
  cover: string;
  route: string;
}

export interface TimelineEvent {
  year: number;
  category: "worldbuilding" | "writing" | "art" | "games" | "music" | "design";
  title: string;
  description: string;
}

// ─── Data ────────────────────────────────────────────────────

export const authorPhoto = AuthorPhoto;

export const worlds: World[] = [
  {
    id: "osgara",
    name: "Osgara",
    subtitle: "The World of Timeless' Aria",
    description:
      "An experiment in worldbuilding through narrative—watching how a rich, lore-filled world reacts to cataclysmic change and fights for its own survival.",
    features: [
      {
        title: "Living Worldbuilding",
        description: "The world evolves through the story, shaped by its own history",
      },
      {
        title: "Published Works",
        description: "Two ~700-page novels and multiple novellas, co-written with a friend",
      },
      {
        title: "Stakes of Existence",
        description: "Will the world survive its own transformation, or collapse?",
      },
    ],
    link: { url: "https://www.timelessaria.com", label: "Explore Osgara" },
  },
  {
    id: "tanaar",
    name: "Tanaar",
    subtitle: "A D&D Open World",
    description:
      "A true open-world D&D setting built from the ground up—complete with cosmology, pantheons, and a campaign where mortals may challenge the gods themselves.",
    features: [
      {
        title: "The Council of 100",
        description: "100 nations, each with unique cultures, races, capitals, symbols (2017, pre-AI)",
      },
      {
        title: "~70 Recorded Sessions",
        description: "A living campaign with years of actual play documented",
      },
      {
        title: "Trial by Fire: Deicide",
        description: "A campaign where the fate of the scales hangs in balance",
      },
    ],
  },
  {
    id: "caiden",
    name: "Caiden",
    subtitle: "Collaborative Worldbuilding",
    description:
      "Assisting my brother in crafting his D&D world—contributing deep lore documents, in-world histories, and short stories that foreshadow events to come.",
    features: [
      {
        title: "Deep Lore Documents",
        description: "Comprehensive in-world texts and historical records",
      },
      {
        title: "In-World Fiction",
        description: "Short stories written from within the world itself",
      },
      {
        title: "Urkaiden Tales",
        description: "Stories that hint at greater mysteries yet to unfold",
      },
    ],
    link: { url: "/story/short-stories", label: "Read the Stories" },
  },
  {
    id: "bereda",
    name: "Bereda",
    subtitle: "The First World (2006)",
    description:
      "My first passion project, begun in 2006. A world with unique creation myths that grew too vast to contain—now resting, waiting for its time.",
    features: [
      {
        title: "Unique Cosmology",
        description: "Creation myths that diverge from traditional fantasy",
      },
      {
        title: "Years of Development",
        description: "Built and expanded from 2006 until it outgrew its bounds",
      },
      {
        title: "Dormant, Not Dead",
        description: "The world still exists, waiting for its story to be told",
      },
    ],
  },
];

export const books: Book[] = [
  {
    title: "Timeless' Aria: The Sapphire Shore",
    status: "Novel",
    link: "https://www.amazon.com/Sapphire-Shore-Timeless-Aria-Book-ebook/dp/B0CNP3RNC5",
  },
  {
    title: "Timeless' Aria: The Ember Tide",
    status: "Novel",
    link: "https://www.amazon.de/dp/3911111207?bestFormat=true",
  },
  {
    title: "Reports of Rebellion",
    status: "Novella",
    link: "https://www.timelessaria.com/novella",
    free: true,
  },
  {
    title: "Heart of Gold",
    status: "Novella",
    link: "https://www.amazon.de/dp/B0CR7VV32Y",
  },
  {
    title: "Scoundrels!",
    status: "Novella",
    link: "https://www.amazon.de/dp/B0CXNT99B9",
  },
  {
    title: "Juniara: Last of the Free",
    status: "Novella",
    link: "https://www.amazon.de/dp/3911111185",
  },
  {
    title: "Hatchling of the Orchard",
    status: "Novella",
    link: "https://www.timelessaria.com/hatchling",
    free: true,
  },
];

export const musicAlbums: MusicAlbum[] = [
  {
    id: "graengale-grove",
    title: "Graengale Grove",
    description: "A journey through dawn, light, and the mysteries of twilight",
    tracks: [
      { id: "dawn", title: "Dawn", src: GraengaleDawn },
      { id: "morning-song", title: "Morning Song", src: GraengaleMorningSong },
      { id: "light", title: "Light", src: GraengaleLight },
      { id: "ballad", title: "The Ballad of Graengale Grove", src: GraengaleBallad },
      { id: "twilight", title: "Dämmerung (Twilight)", src: GraengaleTwilight },
      { id: "night-song", title: "Nachtlied (Night Song)", src: GraengaleNightSong },
      { id: "dark", title: "Dunkel (Dark)", src: GraengaleDark },
    ],
  },
  {
    id: "osgara-sapphire-shore",
    title: "Osgara — The Sapphire Shore",
    description: "An epic orchestral journey through the world of Osgara, from the ashes of Novgara to the shores of sapphire",
    cover: SapphireShoreCover,
    tracks: [
      { id: "ss-prologue", title: "Prologue", src: SapphireT00 },
      { id: "ss-ashes", title: "Ashes of Novgara", src: SapphireT01 },
      { id: "ss-battle-ash", title: "The Battle of Ash", src: SapphireT02 },
      { id: "ss-sapphire-lords", title: "Sapphire Lords", src: SapphireT03 },
      { id: "ss-bastion", title: "Bastion of the Mark", src: SapphireT04 },
      { id: "ss-steed", title: "Ready my Steed!", src: SapphireT05 },
      { id: "ss-coup", title: "The Sapphire Coup", src: SapphireT06 },
      { id: "ss-thousands", title: "Thousands", src: SapphireT07 },
      { id: "ss-symphony", title: "The Symphony of Grahir", src: SapphireT08 },
      { id: "ss-steel", title: "The Sound of Steel", src: SapphireT09 },
      { id: "ss-shattering", title: "The Shattering", src: SapphireT10 },
      { id: "ss-herald", title: "Herald of War", src: SapphireT11 },
      { id: "ss-shore", title: "The Sapphire Shore", src: SapphireT12 },
    ],
  },
  {
    id: "osgara-ember-tide",
    title: "Osgara — The Ember Tide",
    description: "The second chapter of Osgara's musical saga — fire, conflict, and the end of magic",
    cover: EmberTideCover,
    tracks: [
      { id: "et-risen", title: "Risen in Ember", src: EmberT01 },
      { id: "et-epoch", title: "Ember Epoch", src: EmberT02 },
      { id: "et-squabbles", title: "Petty Squabbles (Gothic)", src: EmberT03 },
      { id: "et-visitor", title: "Northern Visitor", src: EmberT04 },
      { id: "et-magicide", title: "Magicide", src: EmberT05 },
      { id: "et-eternal", title: "Flame Eternal", src: EmberT06 },
      { id: "et-magic-end", title: "To Magic's End!", src: EmberT07 },
      { id: "et-fall", title: "Fall from Grace", src: EmberT08 },
      { id: "et-reverie", title: "Reverie of Cinder (Remix)", src: EmberT09 },
    ],
  },
  {
    id: "venerann-ember-tide",
    title: "Venerann's Ember Tide",
    description: "Tales of dragon fire, sapphire lords, and the warbearers of Venerann",
    cover: VenerannCover,
    tracks: [
      { id: "ve-ember-tide", title: "The Ember Tide", src: VenerannT01 },
      { id: "ve-cleansing", title: "Cleansing Flame", src: VenerannT02 },
      { id: "ve-sapphire", title: "Sapphire Lords", src: VenerannT03 },
      { id: "ve-dragon", title: "The Dragon and The Flame", src: VenerannT04 },
      { id: "ve-last", title: "Last of the Sapphire Guard", src: VenerannT05 },
      { id: "ve-flow", title: "Ember's Flow", src: VenerannT06 },
      { id: "ve-warbearers", title: "Warbearers", src: VenerannT07 },
      { id: "ve-magic-end", title: "To Magic's End", src: VenerannT08 },
      { id: "ve-call", title: "Ember's Call", src: VenerannT09 },
      { id: "ve-throvia", title: "Throvia!", src: VenerannT10 },
    ],
  },
  {
    id: "scoundrels-shanties",
    title: "Scoundrel's Shanties",
    description: "Seafaring shanties and tavern songs from the pirates and scoundrels of the Migoran seas",
    cover: ScoundrelsCover,
    tracks: [
      { id: "sc-endless-sea", title: "The Endless Sea", src: ScoundrelT01 },
      { id: "sc-song", title: "Scoundrel's Song", src: ScoundrelT02 },
      { id: "sc-far-waters", title: "Far Waters", src: ScoundrelT03 },
      { id: "sc-bounty", title: "Migoran Bounty", src: ScoundrelT04 },
      { id: "sc-blood", title: "Blood of Salt", src: ScoundrelT05 },
      { id: "sc-shallow", title: "Deckhand Shanty #6 (Shallow)", src: ScoundrelT06 },
      { id: "sc-deep", title: "Deckhand Shanty #6 (Deep)", src: ScoundrelT07 },
      { id: "sc-fw", title: "Deckhand Shanty #6 (Far Waters)", src: ScoundrelT08 },
      { id: "sc-you-and-i", title: "Scoundrel's You & I", src: ScoundrelT09 },
      { id: "sc-bountiful", title: "O Bountiful Sea", src: ScoundrelT10 },
      { id: "sc-sanity", title: "Sanity's Edge", src: ScoundrelT11 },
      { id: "sc-sanity-ballad", title: "Sanity's Edge (Ballad)", src: ScoundrelT12 },
      { id: "sc-voyage", title: "Far Voyage!", src: ScoundrelT13 },
      { id: "sc-captain", title: "Deckhand Shanty #6 (Captain's Song)", src: ScoundrelT14 },
    ],
  },
];

export const gameDesignVideos: VideoItem[] = [
  { id: "Zti-1PIOts8", title: "Game Design" },
  { id: "mfl8MYu2fQk", title: "Game Design" },
  { id: "v0X1w6-MvTY", title: "Game Design" },
  { id: "FEwkVX-4W-c", title: "Game Design" },
  { id: "sf4q-CGqooQ", title: "Game Design" },
  { id: "kOpecsomGVE", title: "Game Design" },
  { id: "jCwHFtA3VeY", title: "Game Design" },
  { id: "9xpBJmvbbNg", title: "Game Design" },
  { id: "RUM9riXGBas", title: "Game Design" },
  { id: "WMvT0ok_i8Y", title: "Game Design" },
  { id: "umult8wqA2w", title: "Game Design" },
  { id: "nNqhZzh41F4", title: "Game Design" },
  { id: "3AkML0j4-14", title: "Game Design" },
  { id: "DwJRYvJyBCA", title: "Game Design" },
  { id: "Gm-RMysWHyI", title: "Game Design" },
  { id: "A3LEds9tkfE", title: "Game Design" },
  { id: "50CPNp4u-iw", title: "Game Design" },
  { id: "AoZywEhoc-M", title: "Game Design" },
  { id: "LCEApAWxbpI", title: "Game Design" },
];

export const paintingVideos: VideoItem[] = [
  { id: "8IfnjLIWBBo", title: "Painting Process" },
  { id: "wlsrWPAnO4E", title: "Painting Process" },
  { id: "lij0TB-H3AU", title: "Painting Process" },
  { id: "Ixw_0BdajgQ", title: "Painting Process" },
  { id: "6wsk04pMTkQ", title: "Painting Process" },
  { id: "Jw_2EClcftk", title: "Painting Process" },
  { id: "r8iAQNrb7TM", title: "Painting Process" },
  { id: "5DVsAps7fKQ", title: "Painting Process" },
  { id: "-4qkpVi0onQ", title: "Painting Process" },
];

export const paintings: Painting[] = [
  { src: Painting16, title: "The Migoran Peaks", medium: "Oils" },
  { src: Painting14, title: "Lost in the Mist", medium: "Oils" },
  { src: Painting12, title: "Northern Summer", medium: "Oils" },
  { src: Painting11, title: "Untrodden Path", medium: "Oils" },
  { src: Painting10, title: "The Well of Life", medium: "Oils" },
  { src: Painting18, title: "Ashen Folk", medium: "Oils" },
  { src: Painting17, title: "For Franzi", medium: "Oils" },
  { src: Painting15, title: "For Frank, and the EasternGraphics Family", medium: "Oils" },
  { src: Painting13, title: "For Lee", medium: "Oils" },
  { src: Painting19, title: "Watercolors & Acrylics", medium: "Acrylics" },
  { src: Painting9, title: "Motra", medium: "Oils" },
  { src: Painting8, title: "Furled Sails (Duh)", medium: "Oils" },
  { src: Painting7, title: "The Blockade of Contara", medium: "Oils" },
  { src: Painting6, title: "Sea of Scoundrels", medium: "Oils" },
  { src: Painting5, title: "Attempt 1", medium: "Oils" },
  { src: Painting4, title: "The World of Osgara", medium: "Acrylics" },
  { src: Painting3, title: "Sebriga", medium: "Acrylics" },
  { src: Painting2, title: "Around King's Range", medium: "Acrylics" },
  { src: Painting1, title: "Giantsfall Tavern", medium: "Acrylics" },
];

export const games: Game[] = [
  {
    id: "kotch",
    title: "Kotch",
    year: 2018,
    description: "Strategic 3-lane card game",
    cover: KotchCover,
    route: "/kotch",
  },
  {
    id: "bountiful-sea",
    title: "Bountiful Sea",
    year: 2023,
    description: "Bluffing dice game of deception",
    cover: BountifulSeaCover,
    route: "/bountiful-sea",
  },
  {
    id: "sands-of-exile",
    title: "Sands of Exile",
    year: 2024,
    description: "Desert survival board game",
    cover: SandsOfExileCover,
    route: "/sands-of-exile",
  },
];

export const creativeTimeline: TimelineEvent[] = [
  { year: 2006, category: "worldbuilding", title: "Bereda", description: "My first world—unique cosmology and creation myths, the spark that started everything." },
  { year: 2010, category: "art", title: "First Paintings", description: "Inspired by Bob Ross, picked up acrylics and never looked back." },
  { year: 2017, category: "worldbuilding", title: "Tanaar", description: "A D&D open world with 100 nations, pantheons, and a cosmology built from scratch." },
  { year: 2017, category: "worldbuilding", title: "Caiden", description: "Collaborative worldbuilding with my brother—deep lore documents and in-world fiction." },
  { year: 2018, category: "games", title: "Kotch", description: "A strategic 3-lane card game designed for a fantasy world." },
  { year: 2018, category: "art", title: "Oil Paintings", description: "Progressed from acrylics to oils—landscapes of Osgara, portraits, and seascapes." },
  { year: 2019, category: "design", title: "Unreal Engine", description: "Began experimenting with level design and cinematics in Unreal Engine." },
  { year: 2021, category: "worldbuilding", title: "Osgara", description: "The World of Timeless' Aria—worldbuilding through narrative, watching a world fight for survival." },
  { year: 2021, category: "writing", title: "The Sapphire Shore", description: "First published novel—a ~700-page epic co-written with a friend." },
  { year: 2022, category: "writing", title: "The Ember Tide", description: "Second novel in the Timeless' Aria series." },
  { year: 2023, category: "writing", title: "Novellas", description: "Reports of Rebellion, Heart of Gold, Scoundrels!, and more." },
  { year: 2023, category: "games", title: "Bountiful Sea", description: "A bluffing dice game of deception on the high seas." },
  { year: 2024, category: "games", title: "Sands of Exile", description: "A desert survival board game." },
  { year: 2024, category: "music", title: "Graengale Grove", description: "Original 7-track album—from Dawn through Dunkel, a journey through twilight." },
];

// Section descriptions used across variants
export const sectionDescriptions = {
  worlds: "It is, I find, the single most engrossing thing to dream up a new world and attempt to breathe life and character into it while maintaining coherence with its inner laws.",
  writing: "I make very little effort to market these publications, as I write them primarily for myself but I do dream of one day taking them to a publisher and seeing just how far my reach for the stars would go.",
  paintings: "Inspired by Bob Ross and how he made painting seem so wonderfully easy, I picked up my first set of Acrylics and never looked back as I progressed through Water Colours and eventually to Oils.",
  games: "These are games made for a Fantasy World, in an attempt to convey a slice of what the people of those worlds would have done for their own entertainment as I find it can be telling of what kind of people they were.",
  music: "Original compositions and soundtracks",
  quote: "Knowledge is limited. Imagination encircles the world.",
};
